import styled from 'styled-components';

export default styled.img<{ flipped?: boolean }>`
  ${props => (props.flipped ? 'transform: rotate(180deg);' : '')};
`;
